<template>
  <v-dialog
    v-model="show"
    persistent
    width="500"
  >
    <v-card
      class="modal-edit-category"
      flat
    >
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Detalhes do rateio - Rateio atual</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="close()"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout
        wrap
        row
        class="pt-4 pb-4 pr-4 pl-4"
      >
        <AppLoadingIcon
          v-if="loading"
          color="#CCCCCC"
          class="my-4"
        />
        <div
          v-else
        >
          <v-flex
            lg12
            class="pt-3 pb-3 gray--text"
          >
            <strong>Realizado por:</strong> {{ apportionmentDetails.doneBy }}
          </v-flex>
          <v-flex
            lg12
            class="pt-3 pb-3 gray--text"
          >
            <strong>Vendedor:</strong> {{ apportionmentDetails.seller }}%
          </v-flex>
          <v-flex
            lg12
            class="pt-3 pb-3 gray--text"
          >
            <strong>Equipe:</strong> {{ apportionmentDetails.team }}%
          </v-flex>
        </div>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApportionmentsDetails } from '@/services/containers/partners/campaigns'
import AppLoadingIcon from '@/components/ui/AppLoadingIcon'

export default {
  name: 'ApportionmentDetailsModal',

  components: {
    AppLoadingIcon
  },

  data: () => ({
    show: false,
    loading: false,
    apportionmentDetails: {},
    partnerId: ''
  }),

  watch: {
    'show': function(value) {
      if (value) this.fetchApportionmentDetails()
    }
  },

  methods: {
    open(partner) {
      this.partnerId = partner._id
      this.show = true
    },

    close() {
      this.partnerId = ''
      this.apportionmentDetails = {}
      this.show = false
    },

    async fetchApportionmentDetails() {
      try {
        this.apportionmentDetails = {}
        this.loading = true
        const campaignId = this.$route.params.id
        const res = await getApportionmentsDetails(campaignId, this.partnerId)
        this.apportionmentDetails = res.data
      } catch (error) {
        // console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="stylus">
.modal-edit-category {
  .app-select {
    padding: 1rem;
  }

  .modal-edit-category-btn {
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
  }
}
</style>
